import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FormTextAreaField } from "../../components/form/text-area";
import moment from "moment";
import successToast from "../toast/successToast";
import errorToast from "../toast/errorToast";
import { api } from "../../redux/apis/api";

const CommentsComponent = ({ tableName, viewId }) => {
  const [data, setData] = useState(null);

  const initialValues = {
    comment: "",
  };

  const validationSchema = Yup.object().shape({
    comment: Yup.string().required("Required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    console.log(values, "values");
    const token = localStorage.getItem("accessToken"); // or get it from where you're storing it

    api
      .post(
        `/ffadmin/create-comment`,
        {
          model_name: tableName,
          record_id: viewId,
          comment: values?.comment,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((res) => {
        console.log(res.data, "res.data");
        successToast(res.message);
        commentsList();
        resetForm();
      })
      .catch((err) => {
        console.error("API Error:", err);
        errorToast(err?.response?.data?.message);
      });
  };

  const commentsList = () => {
    const token = localStorage.getItem("accessToken"); // or get it from where you're storing it

    api
      .post(
        `/ffadmin/list-comment`,
        {
          model_name: tableName,
          record_id: viewId,
        },
        {
          headers: {
            "x-access-token": token,
          },
        }
      )
      .then((res) => {
        console.log(res.data, "res.data");
        setData(res?.data?.data);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    commentsList();
  }, [tableName, viewId]);

  return (
    <section className="my-10">
      <div className="flex justify-between items-center mb-5 bg-background pb-2 z-10">
        <label className="text-fs_18 font-semibold capitalize">Comments</label>
      </div>
      <section>
        {data?.map((item, index) => (
          <div
            key={index}
            className="w-full max-w-[30rem] border-[1px] rounded-lg p-3 my-4"
          >
            <div className="flex justify-between items-center">
              <div className="flex gap-5 items-center">
                <div className="w-[35px] h-[35px] rounded-full">
                  <img
                    src={item?.ffAdminUser?.profile_picture}
                    className="w-full h-full object-contain rounded-full"
                  />
                </div>
                <h1 className="text-fs_18 font-fw_500">
                  {item?.ffAdminUser?.name}
                </h1>
              </div>
              <p className="text-fs_14">
                {moment(item?.createdAt).format("D MMMM YYYY")}
              </p>
            </div>
            <div className="mt-2">
              <p className="text-fs_14">{item?.comment}</p>
            </div>
          </div>
        ))}

        <div className="w-full max-w-[30rem]">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            <Form>
              <FormTextAreaField
                label={"comment"}
                name={"comment"}
                placeholder={`Enter comment`}
              />
              <div className="flex justify-end">
                <button
                  type="submit"
                  className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                >
                  Submit
                </button>
              </div>
            </Form>
          </Formik>
        </div>
      </section>
    </section>
  );
};

export default CommentsComponent;
